import {useQuery} from "@tanstack/react-query";
import {useState} from "react";
import {featureFlagsQuery} from "hooks/useFeature";

/** The feature_flags list for Admin → Feature Flags. The editor reads the same query (hooks/useFeature.ts). */
export const useFeatureFlags = () => {
  const [mutationError, setError] = useState(null);
  const {
    data: featureFlags = [],
    isLoading: loading,
    error: queryError,
    refetch: fetchFeatureFlags,
  } = useQuery(featureFlagsQuery);

  const error = mutationError || (queryError ? "Failed to load feature flags" : null);

  return {featureFlags, loading, error, fetchFeatureFlags, setError};
};
